export function categoriesIndexHref(categoryId?: string | null, courseSearch?: string | null): string {
  const query = new URLSearchParams();
  const category = categoryId?.trim();
  if (category) query.set('category', category);
  const search = courseSearch?.trim();
  if (search) query.set('course_search', search);
  const qs = query.toString();
  return `/categorias${qs ? `?${qs}` : ''}`;
}

export function categoryDetailHref(categoryId: string): string {
  return categoriesIndexHref(categoryId);
}

export function categoryFormBackTo(input: {
  editedCategoryId?: string | null;
  parentId?: string | null;
}): string {
  return categoriesIndexHref(input.editedCategoryId || input.parentId);
}
